/*
 * @Author: whj
 * @Date: 2024-06-12 17:18:49
 * @Last Modified by: whj
 * @Last Modified time: 2025-09-18 16:34:43
 */

import {
  splitLink,
  zidFilter,
  trimFilter,
  getViewportLayout,
  splitPage,
} from "./util";
import { http } from "./http";
import kd from "./kd";

(function () {
  /** 兑换失败 自动再次请求 */
  var exchangeCnt = 0; // 当前请求次数
  var exchangeMax = 3; // 最大请求次数
  var silderSize = 0; // slider每页个数

  var app = {
    /** 视口布局：更新 silderSize（pc=3 / app=1），并对 #fn-app 设置 transform: scale */
    syncViewportLayout() {
      const { mode, scale } = getViewportLayout();
      silderSize = mode === "pc" ? 3 : 1;
      const el = document.getElementById("fn-app");
      if (el) {
        el.style.transform = `scale(${scale})`;
      }
    },

    init() {
      // linkData
      let linkData = splitLink();

      linkData.authorization &&
        localStorage.setItem("token", linkData.authorization);
      linkData.zid && localStorage.setItem("zid", linkData.zid);
      linkData.type && localStorage.setItem("fromType", linkData.fromType);

      // 重置link
      window.history.replaceState(
        {
          page: 1,
        },
        "礼包码兑换",
        `${window.location.origin}${window.location.pathname}`,
      );

      this.syncViewportLayout();
      window.addEventListener("resize", () => {
        this.syncViewportLayout();
      });

      // start
      // 口袋登录
      const _self = this;
      const kdData = kd.freeLoginData();
      const isKd = !!kdData; // 是否在口袋中

      // alert(JSON.stringify({ ...kdData, zid: kdData.area_id}));
      if (isKd) {
        // 保存口袋的大区ID
        linkData.zid && localStorage.setItem("zid", kdData.area_id);

        // 口袋免登录
        http(
          {
            url: "/api/login/kouDai",
            data: { ...kdData, zid: kdData.area_id },
          },
          function ({ code, data, message }) {
            if (code === 0) {
              localStorage.setItem("token", data);
              _self.userInit();
              return;
            }
            _self.showMsg(message);
          },
        );
      } else if (linkData.fromType == "wx") {
        // 微信自动登录
        http(
          {
            url: "/api/login/wxlogin",
            data: {
              token: linkData.authorization,
              zid: linkData.zid,
            },
          },
          function ({ code, data, message }) {
            if (code === 0) {
              localStorage.setItem("token", data);
              _self.userInit();
              return;
            }
            _self.showMsg(message);
          },
        );
      } else {
        // 其他登录
        this.userInit();
      }

      this.advertInit();
    },

    event() {
      const _self = this;
      const placeholder = $("#cdk-placeholder");
      const ipt = $("#cdk-ipt");

      placeholder.on("click", function () {
        $(this).hide();
        ipt[0].focus();
      });

      ipt
        .on("focus", function () {
          placeholder.hide();
        })
        .on("blur", function () {
          // 移除空格
          var val = trimFilter($(this).val());
          ipt.val(val);
          
          if (val.length === 0) {
            placeholder.show();
          }
        });

      $("#cdk-exchange").on("click", function () {
        if ($(this).hasClass("is-gray")) {
          return;
        }
        _self.exchangeFn(ipt.val());
      });

      $("#cdk-again").on("click", function () {
        $("#cdk-success, #cdk-again").hide();
        $("#cdk-form, #cdk-exchange").show();
        ipt.val("").focus();
      });

      // user
      $("#user-bar")
        .on("click", "#fn-login", function () {
          mslogin.login();
        })
        .on("click", "#fn-logout", function () {
          // console.log('logout');
          localStorage.removeItem("token");
          location.reload();
        });

      // slider
      $("body").on("click", ".slider-page__item", function () {
        let idx = $(this).attr("data-idx");

        $(this).addClass("is-crt").siblings().removeClass("is-crt");
        $(`.slider-slider__row[data-idx="${idx}"]`)
          .addClass("is-crt")
          .siblings()
          .removeClass("is-crt");
        _self.advertSyncPrevNext();
      });

      $("#slider-prev").on("click", function () {
        _self.advertChange("prev");
      });

      $("#slider-next").on("click", function () {
        _self.advertChange("next");
      });
    },

    showMsg(msg) {
      let dom = $("#fn-msg");

      if (!dom.hasClass("fn-show")) {
        dom.html(msg).addClass("fn-show");

        setTimeout(() => {
          dom.removeClass("fn-show");
        }, 3000);
      }
    },

    // 用户信息
    userInit() {
      const areaId = localStorage.getItem("zid") || 0;
      const _self = this;
      // const zid = '17';

      http(
        { url: "/api/user/getUserInfo", data: { areaId } },
        function ({ code, data, message }) {
          // _self.showMsg(JSON.stringify(data));
          // 已登录
          if (code === 0) {
            let HTML = `欢迎，${zidFilter(data.areaId)}- <strong>${data.nickName}</strong>`;

            // 如果是wegame || steam 则增加退出
            const otherArr = ["17", "18", "21", "22"];
            otherArr.forEach((ele) => {
              if (ele == data.areaId) {
                HTML +=
                  ' <button type="button" class="user-link" id="fn-logout">【退出】</button>';
              }
            });

            $("#user-bar").html(HTML);
          } else if (code === 11) {
            // 角色不存在
            _self.showMsg(message);
            $("#cdk-exchange").addClass("is-gray");
          } else {
            // error
            _self.showMsg(message);
          }

          // 事件绑定
          _self.event();
        },
      );
    },

    // 开始兑换
    exchangeFn(str: string | number) {
      let _self = this;

      if (str === "") {
        this.error("礼包码不能为空");
        return;
      }

      $("#cdk-exchange").addClass("is-gray");

      // 发起请求
      http(
        {
          type: "post",
          url: "/api/cdk/reward",
          data: { code: str, areaId: localStorage.getItem("zid") },
        },
        function ({ code, data, message }) {
          //403:无资格兑换，400 参数错误， 1204 已兑换
          if (code === 0) {
            // 成功
            $("#cdk-form, #cdk-exchange, #cdk-error").hide();
            $("#cdk-success, #cdk-again").show();

            // 请求成功 重置为0
            _self.resetExchange();
            return;
          }

          //403:无资格兑换，400 参数错误， 1204 已兑换 ,10 大区无效，429 活动火爆，1000礼包码无效，
          if (code !== 429) {
            _self.resetExchange();
            _self.error(message);
            return;
          }

          /** code=429 执行 */
          // 请求失败 +1
          exchangeCnt += 1;
          // 请求次数 < 最大请求量 可再次请求
          if (exchangeCnt < exchangeMax) {
            _self.exchangeFn(str);
          } else {
            // 超出次数则提示以错误  重置为0
            _self.resetExchange();
            _self.error("兑换火爆，请稍后再试～");
          }
        },
      );
    },

    // 重置兑换按钮
    resetExchange() {
      exchangeCnt = 0;
      $("#cdk-exchange").removeClass("is-gray");
    },

    /** 当前页前后（环形）：仅在 .slider-slider__row 上标 is-prev / is-next，供样式表选中上一屏、下一屏 */
    advertSyncPrevNext() {
      const total = $(".slider-slider__row").length;
      $(".slider-slider__row").removeClass("is-prev is-next");
      if (total <= 1) {
        return;
      }
      const crt = +($(".slider-slider__row.is-crt").attr("data-idx") || 0);
      const prevIdx = crt === 0 ? total - 1 : crt - 1;
      const nextIdx = crt === total - 1 ? 0 : crt + 1;
      $(`.slider-slider__row[data-idx="${prevIdx}"]`).addClass("is-prev");
      $(`.slider-slider__row[data-idx="${nextIdx}"]`).addClass("is-next");
    },

    // 广告位 翻页
    advertChange(type = "") {
      const total = $(".slider-slider__row").length;
      const crt = +$(".slider-slider__row.is-crt").attr("data-idx");
      let changeCrt = 0;

      if (type === "prev") {
        changeCrt = crt > 0 ? crt - 1 : total - 1;
      } else if (type === "next") {
        changeCrt = crt === total - 1 ? 0 : crt + 1;
      }

      $(`.slider-slider__row[data-idx="${changeCrt}"]`)
        .addClass("is-crt")
        .siblings()
        .removeClass("is-crt");
      $(`.slider-page__item[data-idx="${changeCrt}"]`)
        .addClass("is-crt")
        .siblings()
        .removeClass("is-crt");

      this.advertSyncPrevNext();
      // console.table({ total, crt, changeCrt });
    },

    // 广告位 格式化
    advertView(arr) {
      // slider 分页（条数与 syncViewportLayout 中的 pc/app 一致）
      const size = silderSize || 3;
      const { mode } = getViewportLayout();
      const isPc = mode === "pc";
      const total = Math.ceil(arr.length / size);
      let crt = 0;

      // view
      let pageView = "";
      let liView = "";
      for (let i = 0; i < total; i++) {
        pageView += `<button type="button" data-idx="${i}" class="slider-page__item ${i == crt ? "is-crt" : ""}"></button>`;

        let row = arr.slice(i * size, (i + 1) * size);
        let jLen = row.length;
        let linkView = [];
        for (let j = 0; j < jLen; j++) {
          const imgSrc = isPc ? row[j].imgUrl : row[j].mbImgUrl;
          linkView.push(`<a href="${row[j].link}" target="_blank" class="slider-slider__item">
                        <img src="${imgSrc}" alt="${row[j].name}" class="slider-slider__pic">
                    </a>`);
        }
        liView += `<li class="slider-slider__row ${i == crt ? "is-crt" : ""}" data-idx="${i}">${linkView.join("")}</li>`;
      }

      $("#slider-page").html(pageView);
      $("#slider-slider").html(liView);
      this.advertSyncPrevNext();
      if (total === 1) {
        $("#slider-prev, #slider-next").hide();
      }
    },

    // 广告位 初始化
    advertInit() {
      const _self = this;
      http({ url: "/api/cdk/getActivityList" }, ({ code, data, message }) => {

        if (code === 0) {
          this.advertView(data);
          return;
        }

        // error
        _self.showMsg(message);
      });
    },

    // 注销
    logout() {
      http({ url: "/api/user/getUserInfo" });
    },

    // 报错
    error(msg) {
      const error = $("#cdk-error");
      error.html(msg).show();
    },
  };

  app.init();
})();
